import axios from 'axios'
import router from "@/router";
import { Message } from 'element-ui'
import { Toast } from 'vant'
import { uuid } from '@/utils'
import store from '@/store' // 导入您的 store

// 需要静默处理错误的接口URL列表
const silentErrorUrls = [
  '/ssb/newOauth/authorize',
  '/ssb/newOauth/accessToken',
  '/ssb/newOauth/userInfo',
  '/ssb/newOauth/refresh/accessToken',
  '/ssb/newOauth/getUser'
]

// 判断请求URL是否在静默列表中
function isSilentUrl(config) {
  if (!config || !config.url) return false
  return silentErrorUrls.some(url => config.url.includes(url))
}
let baseUrl = window.g.baseUrl
// 开发环境
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/apply-online-server'
// 编译环境
} else {
  baseUrl = window.g.baseUrl
}

// 配置请求头
const Axios = axios.create({
  baseURL: baseUrl
})
// 添加请求拦截器
Axios.interceptors.request.use(function (config) {

  // 在发送请求之前做些什么
  config.headers.operateSource = 2
  // 根据路由路径判断是移动端还是web端
  const isMobile = router.app.$route.path.includes('m-')
  config.headers.deviceType = isMobile ? '' : 1  // web端为1

  // 如果是调用 /login/saveLoginInfoSh 接口，生成新的 sessionId
  if (config.url && config.url.includes('/login/saveLoginInfoSh')) {
    const newSessionId = uuid()
    localStorage.setItem('sessionId', newSessionId)
    config.headers.sessionId = newSessionId
  } else {
    // 其他接口使用已有的 sessionId
    config.headers.sessionId = localStorage.getItem('sessionId')
  }

  // 根据请求体中的复议机关名称设置 belongOrg 请求头
  // belongOrg: 1=上海市人民政府案件, 2=上海市司法局案件
  if (config.data && config.data.caseApplyDetail && config.data.caseApplyDetail.reconsiderationAgencyName) {
    const agencyName = config.data.caseApplyDetail.reconsiderationAgencyName
    // 如果复议机关是"上海市司法局"，设置 belongOrg 为 2，否则为 1
    config.headers.belongOrg = agencyName.includes('上海市司法局') ? '2' : '1'
  }

  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
Axios.interceptors.response.use(function (response) {

  if (response.config.responseType === 'blob') {
    // 下载文件接口：正常返回文件流；若后端返回 JSON（application/json）则视为错误
    const contentType = (response.headers && response.headers['content-type']) || ''
    if (contentType.indexOf('application/json') !== -1) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          let msg = '下载失败'
          try {
            const parsed = JSON.parse(reader.result)
            msg = parsed.msg || parsed.message || msg
          } catch (e) {
            // 解析失败保持默认提示
          }
          reject(new Error(msg))
        }
        reader.onerror = () => reject(new Error('下载失败'))
        reader.readAsText(response.data)
      })
    }
    return response
  } else if (response.data.code !== '0') {
    // 后端的msg没有放在data里面
    if (response.data.code == '999') {


      if(router.app.$route.path.includes('m-')){
        Toast('验证已过期，请重新去登记/查询页面验证')
        router.app.$router.push({
          name: "MCodeSearch"
        });
      } else {
        store.dispatch('clearLoginStatus')
        // 清除登录相关数据
        localStorage.removeItem('applicantInfo')
        localStorage.removeItem('applicantCategory')
        localStorage.removeItem('sessionId')
        localStorage.removeItem('oprate')
        localStorage.removeItem('loginIdentificationCard')
        localStorage.removeItem('loginName')
        localStorage.removeItem('isLogin')
        localStorage.removeItem('isRegistered')
        Message.warning('验证已过期，请重新去登记/查询页面验证')
        router.app.$router.push({
          name: "CodeSearch"
        });
      }

      return
    }
    if (!response.config.silentError && !isSilentUrl(response.config)) {
      const errMsg = response.data.msg || response.data.message || '后台服务异常'
      const silentMessages = ['系统异常', '后台服务异常']
      if (!silentMessages.includes(errMsg)) {
        Message.error(errMsg)
      } else {
        console.error('Filtered error message:', errMsg)
      }
    }
    return response
  } else {
    return response
  }
}, function (error) {
  if ((error.config && error.config.silentError) || isSilentUrl(error.config)) {
    console.error('Silent: 服务器连接失败', error)
  } else {
    console.error('服务器连接失败', error)
  }
  return Promise.reject(error)
})
export default Axios
